import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {hideModal, CONFIRM, CONFIRM_TYPE_PRIMARY, CONFIRM_TYPE_WARNING} from '../../../modules/modals'
import {LOADER_BAR_COLOR} from '../../../settings/constants'
import { connect } from 'react-redux'
import LoadingBar from 'react-redux-loading-bar'
import cn from 'classnames'


class Confirm extends Component {
    render() {
        let {zIndex, title, confirmText, okButtonTxt, cancelButtonTxt, okCb, errors = [], infoType = ""} = this.props
        let {formatMessage} = this.context
        if (!okButtonTxt) okButtonTxt = formatMessage('Ok')
        if (!cancelButtonTxt) cancelButtonTxt = formatMessage('Cancel')

        return (
            <Modal
                isOpen = {true}
                style = {{
                    overlay : {zIndex},
                }}
                onRequestClose={this.handleCancel}
                overlayClassName = "custom-modal"
                className = "custom-modal-content create-dialog-modal-content"
            >
                <div className="posr">
                    <div className="loader-bar-wrapper-absolute">
                        <LoadingBar style={{backgroundColor: LOADER_BAR_COLOR}} />
                    </div>
                </div>
                <div className="create-dialog-modal-content__header">
                    <div className="create-dialog-modal-content__title">{formatMessage(title)}</div>
                    <div
                        onClick={this.handleCancel}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className={cn("create-dialog-modal-content__body", {
                    "create-dialog-modal-content__body--info" : infoType === CONFIRM_TYPE_PRIMARY,
                    "create-dialog-modal-content__body--warning" : infoType === CONFIRM_TYPE_WARNING
                })}>
                    <form className="create-dialog-form">
                        <div className="row mb-5">
                            <div className={cn("col-xs-12 text-center", {
                                "text-primary" : infoType === CONFIRM_TYPE_PRIMARY,
                                "text-warning" : infoType === CONFIRM_TYPE_WARNING,
                            })}>{formatMessage(confirmText)}</div>
                        </div>
                        {
                            !!errors.length &&
                            <div className="row mb-5">
                                <div className="col-xs-12 text-danger">
                                    {
                                        errors.map(error => <p key={error}>{formatMessage(error)}</p>)
                                    }
                                </div>
                            </div>
                        }
                        <div className="create-dialog-form__group flex">
                            <button
                                onClick={okCb}
                                className="btn btn-primary mr-auto"
                                type="button"
                            >{formatMessage(okButtonTxt)}</button>
                            <button
                                onClick={this.handleCancel}
                                className="btn btn-warning"
                                type="button"
                            >{formatMessage(cancelButtonTxt)}</button>
                        </div>
                    </form>
                </div>
            </Modal>
        )
    }

    handleCancel = () => {
        let {hideModal, cancelCb} = this.props
        if (typeof cancelCb === 'function') return cancelCb()

        hideModal({ modalType : CONFIRM})
    }
    static contextTypes = {formatMessage: PropTypes.func}
}

export default connect(
    null,
    {hideModal}
)(Confirm)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/modals/common/Confirm.js